export default "__VITE_PUBLIC_ASSET__729ba9b8__"